// Formats an exact decimal string with thousand separators, rounded half away from zero to decimals, or with its own decimals
// when decimals is null, e.g. ("-1234567.125", 2) -> "-1 234 567.13". Exact also for the 18 decimals of accountingAmount.
export const formatDecimal = (value: string | null | undefined, decimals: number | null): string => {
    if (value === null || typeof value === "undefined" || value === "") return "";
    const negative = value.startsWith("-");
    const [integerPart, fractionPart = ""] = value.replace("-", "").split(".");
    const scale = decimals === null ? fractionPart.length : decimals;
    const fraction = fractionPart.padEnd(scale + 1, "0");
    let units = BigInt(integerPart + fraction.slice(0, scale));
    if (fraction.length > scale && fraction[scale] >= "5") units += 1n;
    const digits = units.toString().padStart(scale + 1, "0");
    const integer = digits.slice(0, digits.length - scale).replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
    return (negative && units !== 0n ? "-" : "") + integer + (scale > 0 ? "." + digits.slice(-scale) : "");
};
